import { ActionType, Action, fileState } from "../actions/types"

const initialFileState: fileState = {
  files: [
    {
      loadNumber: "",
      files: []
    }
  ]
}

const fileReducer = (state: fileState = initialFileState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_FILES:
      return {
        ...state,
        files: action.payload
      }
    default:
      return state
  }
}

export default fileReducer
